import React, { useState, useEffect } from 'react'
import { Typography, IconButton, TableRow, Box } from '@mui/material'
import { ChartBarHorizontalCustom, ProgressionFilters, MuiButton, MuiMultiSelect, TableViewRowWithBars, MuiIconButton } from '../../../../components'
import { LEGEND_TEXT_COLOR_MAP } from '../../../../constants'

import { getObjectAsArray, charWidthFunc, sortByKey, sortingDataForProgressionTabList, getDistinctValues, removeSpecialCharFromLhs } from '../../../../util'
import { ArrowDown, IconReportSearch, ClosePopup } from '../../../../assets/images/icons'
import { IconClose } from '../../../../assets/images/iconsV2'
import PercentSplitGraph from './percentSplit'

import {
  BarWrap,
  IssuesWrap,
  SegmentRow,
  SegmentRowContent,
  SegmentTitleL1,
  SegmentTitle,
  SegmentWrap,
  ProgressionWrapper,
  SegmentProductsWrapper,
  NoDataFound,

  SegmentRowHeading,
  SegmentRowDetails,
  SegmentDetailsLevel2,
  SegmentDetailsLevel2Title,
  SegmentDetailsLevel2ListingLHS,
  SegmentAccordionLevel2Wrap,
  SegmentAccordionLevel2Heading,
  SegmentAccordionLevel2Details,
  SegmentDetailsLevel2ListingRHS,
  SegmentAccordionLevel3Heading,
  SegmentAccordionLevel3Wrap,
  SegmentAccordionLevel3SubHeading,
  SegmentAccordionLevel3Details,
} from './style'

const ComparisonTable = ({
  keyOrdering,
  data,
  segmentData = {},
  maxValue,
  type,
  filterType,
  insightsElementType,
  expanded,
  filterUpdated,
  periodInOrder,
  isSegmentsComponent,
  showTableGrid
}) => {
  const [segmentDataLevel1, setSegmentDataLevel1] = useState()
  const [segmentDataL1Filtered, setSegmentDataL1Filtered] = useState({
    drivers: [],
    segments: [],
    periods: [],
  })
  const [driverFilter, setDriverFilter] = useState([])
  const [segmentsFilter, setSegmentsFilter] = useState([])
  const [periodFilter, setPeriodFilter] = useState([])
  const [filterSelectAll, setFilterSelectAll] = useState({ drivers: true, segments: true, periods: true, })

  const [segmentDataLevel3, setSegmentDataLevel3] = useState()
  const [segmentDataLevel3MaxValue, setSegmentDataLevel3MaxValue] = useState()
  const [progressionData, setProgressionData] = useState(null)
  const [onLoadProgressionData, setOnLoadProgressionData] = useState(null)
  const [defaultProgressionData, setDefaultProgressionData] = useState(null)
  const [segmentWidth, setSegmentWidth] = useState(0)
  const [segmentItemWidth, setSegmentItemWidth] = useState(0)

  // const hidePercentageSplits = ['SearchDriversProgression', 'DriversProgressionWithoutSentiments', 'SegmentDriversOnlyAnalysisWithoutSentiments']
  const showSpiderGraph = ['SegmentDriversAnalysis'].includes(insightsElementType)

  ////////////// ADDING L1, L2 & L3 | START...
  const getData = (
    dd,
    field = 'SegmentDrivers',
    field2 = 'SegmentDrivers',
    level = 0,
    isInner = true
  ) => {
    const obj = {}
    const percentArr = []
    for (let index = 0; index < dd?.length; index++) {
      const element = dd[index]
      const keyName = element.parentDriveName

      const driverElement = element?.[field]?.[field2]
      const drivers = Array.isArray(driverElement)
        ? driverElement
        : Object.keys(driverElement || {})?.length
          ? [driverElement]
          : []

      for (let j = 0; j < drivers.length; j++) {
        const innerElement = drivers[j]
        const key = level === 1 ? innerElement.AttributeName : innerElement.SubAttributeName

        const associationData = [
          {
            SearchKeywords: innerElement.Percent,
          },
        ]

        const multiBarData = [
          {
            Positive: innerElement.PositivePercent,
            Neutral: innerElement.NeutralPercent,
            Mixed: innerElement.MixedPercent,
            Negative: innerElement.NegativePercent,
          },
        ]


        let objKey = innerElement?.TargetSegment ? innerElement.TargetSegment : keyName
        if( innerElement?.TargetSegment === '' ) objKey = keyName

        obj[key] = {
          ...(obj[key] || {}),
          [objKey]: { // ADDED THIS LINE AS SegmentDriversAnalysis TYPE WAS NOT SHOWING LEVEL 2
          // [innerElement?.TargetSegment ?? keyName]: { // ADDED THIS LINE AS SegmentDriversAnalysis TYPE WAS NOT SHOWING LEVEL 2
          // [keyName]: { // THIS LINE WAS CAUSING ISSUE IN SegmentDriversAnalysis TYPE AS LEVEL 2 WAS NOT SHOWING CORRECTLY
            ...innerElement,
            // DriverAttributeStandouts_new: innerElement?.DriverAttributeStandouts_new || [],
            // DriverAttributes_new: innerElement?.DriverAttributes_new || [],

            data: type ? associationData : multiBarData,
            // data: multiBarDataCount === 0 ? associationData : multiBarData
          },
        }
        percentArr.push(innerElement.Percent)
      }
    }

    const maxPercent = Math.max(...percentArr)
    return { object: obj, maxVal: maxPercent }
  }

  const expandLevel1Func = (key) => {
    let dataLevel1 = { ...segmentDataLevel1 }
    dataLevel1[key].expandedLevel1 = !dataLevel1[key]?.expandedLevel1
    setSegmentDataLevel1(dataLevel1)
  }

  const expandLevel2Func = (key, index, key2, showButton = false) => {
    const dataLev2 = { ...segmentDataLevel1 }
    const getDataLevel3FuncData = getDataLevel3Func(dataLev2[key].dataLevel2[key2], key2) // {object:obj, maxVal:maxPercent}

    let dataLev3 = getDataLevel3FuncData.object
    if (Object.keys(dataLev3).length === 0) {
      dataLev3 = null
    }
    if (showButton) return isNaN(dataLev3)

    setSegmentDataLevel3(dataLev3)
    setSegmentDataLevel3MaxValue(getDataLevel3FuncData.maxVal)

    const dataLev2ObjectKeys = Object.keys(dataLev2)
    for (let i = 0; i < dataLev2ObjectKeys.length; i++) {
      dataLev2[dataLev2ObjectKeys[i]].expandedLevel2 = false
    }

    dataLev2[key].expandedLevel2 = true
    dataLev2[key].expandedLevel2Index = index
    dataLev2[key].expandedLevel2Key = key2

    setSegmentDataLevel1(dataLev2)
  }

  const getDataLevel1Func = (key) => {
    const objKeys = Object.keys(segmentData[key])
    const level2Array = []
    for (let i = 0; i < objKeys.length; i++) {
      const finalObject = { ...segmentData[key][objKeys[i]], parentDriveName: objKeys[i] }
      if(finalObject?.DriverAttributeStandouts?.DriverAttributeStandout){
        finalObject.DriverAttributeStandouts.DriverAttributeStandout = getObjectAsArray(finalObject.DriverAttributeStandouts.DriverAttributeStandout)
      }
      if(finalObject?.DriverAttributes?.DriverAttributeElement){
        finalObject.DriverAttributes.DriverAttributeElement = getObjectAsArray(finalObject.DriverAttributes.DriverAttributeElement)
      }
      level2Array.push(finalObject)
    }

    const fData = getData(level2Array, 'DriverAttributes', 'DriverAttributeElement', 1)
    return fData
  }

  const getDataLevel3Func = (segmentData, key) => {
    const objKeys = Object.keys(segmentData)
    const level3Array = []
    for (let i = 0; i < objKeys.length; i++) {
      const finalObject = { ...segmentData[objKeys[i]], parentDriveName: objKeys[i] }
      level3Array.push(finalObject)
    }
    return getData(level3Array, 'DriverSubAttributes', 'DriverSubAttributeElement', 2)
  }
  const closeLevel3 = (key) => {
    let dataLev2 = { ...segmentDataLevel1 }
    dataLev2[key].expandedLevel2 = false
    dataLev2[key].expandedLevel2Index = null
    dataLev2[key].expandedLevel2Key = null
    setSegmentDataLevel3(null)
    setSegmentDataLevel1(dataLev2)
  }

  const filterChangeFunc = (data) => {
    setSegmentDataL1Filtered(data)
    filterUpdated()
  }

  const getDriversFunc = () => {
    return Object.keys(segmentData) // THIS LINE WILL KEEP THE ORDER AS VOLUME, WHICH IS CORRENT..
    // return sortingDataForProgressionTabList(Object.keys(segmentData)) // NOTE: WE CANNOT ADD ORDERING AS ITS ORDERED BY VOLUME
  }
  const getSegmentsFunc = () => {
    const drivers = Object.keys(segmentData)
    const finalData = drivers
      .map((d) => Object.keys(segmentData[d]))
      .flat(1)
      .filter((value, index, array) => array.indexOf(value) === index)
    // const s = sortingDataForProgressionTabList(finalData)
    // return s
    return finalData
    // DEVELOPMENT IS PENDING ..
    // return periodInOrder
  }

  const getL2HeadingFunc = (param) => {
    const keys = Object.keys(param.dataLevel1)[0]
    const str = param.dataLevel1[keys].DriverName
    return str || ''
  }
  ////////////// ADDING L1, L2 & L3 | END...

  const getMaxValueAndTest = (txtArray) => {
    let obj = txtArray.map((t) => ({ name: t, value: t.length }))
    let maxVal = { name: '', value: 0 }
    for (let i = 0; i < obj.length; i++) {
      if (obj[i].value > maxVal.value) {
        maxVal = { name: obj[i].name, value: obj[i].value }
      }
    }
    return charWidthFunc(maxVal.name)
  }

  // const setSegmentWidthFunc = (text) => {
  //   const wid = getMaxValueAndTest([text])
  //   if (wid > segmentWidth) {
  //     setSegmentWidth((prev) => Math.max(prev, wid))
  //   }
  //   return text
  // }

  ////////////// ADDING FILTER CODING | START...
  const onChangeSelect = (type, newArray, method, allValue = false) => {
    if (!progressionData) {
      console.warn('onChangeSelect called before progressionData was set')
      return
    }
    const prevArray = progressionData[type] || []
    const defaultArray = defaultProgressionData?.[type] || []

    // Initialize new data copy
    const newProgression = {
      ...progressionData
    }

    let finalArray = []

    if (allValue) {
      // Select all override
      finalArray = [...defaultArray]
    } else if (newArray.length === 0) {
      // finalArray = [...defaultArray]
    } else if (newArray.length < prevArray.length) {
      // User reduced selection
      finalArray = newArray
    } else {
      // User added selection(s)
      // Merge and dedupe to preserve prior selections
      finalArray = getDistinctValues([...prevArray, ...newArray])
    }

    newProgression[type] = finalArray

    if(finalArray.length === 1 && finalArray[0] === 'All'){
      if(newProgression.periods[0] === 'All') {
        newProgression.periods = defaultProgressionData.periods
      }
      if(newProgression.drivers[0] === 'All') {
        newProgression.drivers = defaultProgressionData.drivers
      }
    }

    // If you also want to reset other filters or keep them, ensure newProgression has correct values for other types
    // Already spreading progressionData ensures other types remain

    // Update state
    method(finalArray)
    setProgressionData(newProgression)
    filterChangeFunc(newProgression)
    
    
    const data = {...defaultProgressionData}
    const data2 = {...progressionData}
    const dataCheck = data[type].length === data2[type].length
    setFilterSelectAll(prev => ({...prev, [type]: dataCheck}))
  }


  const onChangeSelectAll = (type, array , method) => {
    const data = {...defaultProgressionData}
    const data2 = {...progressionData}

    const dataCheck = !(filterSelectAll[type] === true && data[type].length === data2[type].length )

    // method(data[type])
    method(dataCheck ? data[type] : [])
    setProgressionData(data)
    filterChangeFunc(data)
    setFilterSelectAll(prev => ({...prev, [type]: !filterSelectAll[type]}))
  }
  ////////////// ADDING FILTER CODING | END...

  ////////////// ADDING USE-EFFECT | START...
  useEffect(() => {
    const objectKeys = Object.keys(segmentData)
    const segData = {}
    for (let i = 0; i < objectKeys.length; i++) {
      const getDataLevel1FuncData = getDataLevel1Func(objectKeys[i]) // {object:obj, maxVal:maxPercent}
      
      segData[objectKeys[i]] = {
        dataLevel1: segmentData[objectKeys[i]],
        expandedLevel1: false,
        dataLevel2: getDataLevel1FuncData.object,
        expandedLevel2: false,
        expandedLevel2Index: null,
        expandedLevel2MaxValue: getDataLevel1FuncData.maxVal,
        expandedLevel2Key: '',
      }
    }
    setSegmentDataLevel1(segData)
  }, [segmentData])

  useEffect(() => {
    if (segmentDataLevel1) {
      const dataLev2 = { ...segmentDataLevel1 }
      const dataLev2ObjectKeys = Object.keys(dataLev2)
      for (let i = 0; i < dataLev2ObjectKeys.length; i++) {
        dataLev2[dataLev2ObjectKeys[i]].expandedLevel1 = expanded
        dataLev2[dataLev2ObjectKeys[i]].expandedLevel2 = false
      }
      setSegmentDataLevel1(dataLev2)
      filterUpdated()
    }
  }, [expanded])

  useEffect(() => {
    filterUpdated()
  }, [segmentDataLevel1])

  useEffect(() => {
    setProgressionData({ drivers: getDriversFunc(), [filterType]: getSegmentsFunc() })
  }, [])

  const updateDefaultDatas = (defaultData) => {
      if ( defaultProgressionData === null ) {
        setDefaultProgressionData(defaultData)
        setSegmentsFilter(defaultData.segments)
        setDriverFilter(defaultData.drivers)
        setPeriodFilter(defaultData.periods)
      }
  }

  useEffect(() => {
    if (progressionData?.periods?.length > 0 && filterType === 'periods') {
      const data = { ...progressionData, periods: progressionData.periods.slice(0, 12) }
      setOnLoadProgressionData(data)
      updateDefaultDatas(data)
    }
    else if (progressionData?.segments?.length > 0 && filterType === 'segments') {
      const data = { ...progressionData, segments: progressionData.segments.slice(0, 12) }
      setOnLoadProgressionData(data)
      updateDefaultDatas(data)
    }
  }, [progressionData])

  useEffect(() => {
    if (progressionData?.periods?.length > 0 && filterType === 'periods' || progressionData?.segments?.length > 0 && filterType === 'segments') {
      updateDefaultDatas(onLoadProgressionData)
    }
  }, [onLoadProgressionData])
  ////////////// ADDING USE-EFFECT | END...

  useEffect(() => {
    let maxWidth = 0
    Object.keys(segmentData).map((key, i) => {
      const item = segmentData[key]
      const maxWid = getMaxValueAndTest(Object.keys(item))
      maxWidth = Math.max(maxWidth, maxWid)
    })
    setSegmentItemWidth(maxWidth)
  }, [])


  return (
    <SegmentWrap className={'segmentWrap'}>
      {Object.keys(segmentData)?.length > 0 && progressionData?.drivers.length >= 0 && (
        <ProgressionWrapper>

          {defaultProgressionData?.periods?.length > 0 && <MuiMultiSelect
            name='periods'
            placeholder='Periods'
            onChange={(e) => onChangeSelect('periods', e , setPeriodFilter)}
            onSelectAll={(e) => onChangeSelectAll('periods', defaultProgressionData.periods , setPeriodFilter , true)}
            data={defaultProgressionData.periods}
            value={periodFilter}
            style={{ width: '200px' }}
          />}

          {defaultProgressionData?.segments?.length > 0 && <MuiMultiSelect
            name='segments'
            placeholder='Segments'
            onChange={(e) => onChangeSelect('segments', e , setSegmentsFilter)}
            onSelectAll={(e) => onChangeSelectAll('segments', defaultProgressionData.segments , setSegmentsFilter , true)}
            data={defaultProgressionData.segments}
            value={segmentsFilter}
            style={{ width: '200px' }}
          />}

          {defaultProgressionData?.drivers?.length > 0 && <MuiMultiSelect
            name='drivers'
            placeholder='Drivers'
            onChange={(e) => onChangeSelect('drivers', e , setDriverFilter)}
            onSelectAll={(e) => onChangeSelectAll('drivers', defaultProgressionData.drivers , setDriverFilter , true)}
            data={defaultProgressionData.drivers}
            value={driverFilter}
            style={{ width: '200px' }}
          />}

          <Box style={{display: 'none'}}><ProgressionFilters
            data={progressionData}
            onChange={filterChangeFunc}
            onLoadShowData={onLoadProgressionData}
          /></Box>
        </ProgressionWrapper>
      )}

      {showSpiderGraph && data && <PercentSplitGraph data={data} />}
      {data?.map((item, index) => {
          return (
            <SegmentRow key={index} data-segment={item.SegmentType} className={'segmentRow'} style={{display: 'none'}}>
              {item?.data.map((productItem, i) => {
                if (productItem?.SegmentName === 'NA') return null
                return (
                  <SegmentRowContent key={i}>
                    <SegmentTitle style={{ minWidth: segmentItemWidth + 5 + 'px' }}>
                      {productItem.SegmentName}
                    </SegmentTitle>
                    <BarWrap className={productItem?.type?.toLowerCase()}>
                      <ChartBarHorizontalCustom
                        showInside={false}
                        bottomText={false}
                        data={productItem.data}
                        valueInPercent={productItem.SegmentType.indexOf('Percent') !== -1}
                        maxPercentRatio={productItem.SegmentMaxValue}
                        maxWidth='100%'
                      />
                    </BarWrap>
                    <Typography className='outerText'>
                      {productItem.SegmentValue}
                      {productItem.SegmentType.indexOf('Percent') !== -1 && '%'}
                    </Typography>
                  </SegmentRowContent>
                )
              })}
            </SegmentRow>
          )
      })}

      {/* {segmentData && Object.keys(segmentData).map((key, i) => { */}
      {(driverFilter?.length === 0 || segmentsFilter?.length === 0 || periodFilter?.length === 0) && <NoDataFound>Looks like you've cleared all filters. Select specific options to see the data again.</NoDataFound>}
      {segmentData &&
        segmentDataLevel1 &&
        (driverFilter?.length > 0 && (segmentsFilter?.length > 0 || periodFilter?.length > 0)) &&
        segmentDataL1Filtered[filterType] &&
        segmentDataL1Filtered.drivers.map((key, i) => {
          const item = segmentData[key]
          const itemLevel1 = segmentDataLevel1[key]
          const selectedItemsL1 = {}
          const arr1 = segmentDataL1Filtered[filterType]
          for (let s = 0; s < arr1.length; s++) {
            if (item[arr1[s]]) {
              item[arr1[s]]['insightsElementType'] = insightsElementType;
              selectedItemsL1[arr1[s]] = item[arr1[s]]
            }
          }

          if (Object.keys(selectedItemsL1).length === 0) {
            return false
          }
          const isExpandClicked = (itemLevel1?.expandedLevel1) ? 'Collaspe' : 'Expand'

          return (
            <SegmentRow key={key} className="segmentRows LEVEL1">
              <SegmentRowHeading className={itemLevel1?.expandedLevel1 ? 'selected' : ''}>
                {key}
                {Object.keys(itemLevel1?.dataLevel2)?.length > 0 && (
                  <MuiIconButton size='small' onClick={(e) => expandLevel1Func(key)} tooltip={isExpandClicked} align='right'>
                    <IconReportSearch />
                  </MuiIconButton>
                )}
              </SegmentRowHeading>
              <SegmentRowDetails>
                {showTableGrid === 'graph' && (
                  <BarGraphsWrapper
                    insightsElementType={insightsElementType}
                    keyOrdering={keyOrdering}
                    item={selectedItemsL1}
                    maxValue={maxValue}
                    level='L1'
                  />
                )}
                {showTableGrid === 'table' && (
                  <TableGraphsWrapper
                    keyOrdering={keyOrdering}
                    item={selectedItemsL1}
                    maxValue={maxValue}
                  />
                )}
              </SegmentRowDetails>
              {/* {itemLevel1?.expandedLevel1 && Object.keys(itemLevel1?.dataLevel2)?.length > 0 && ( */}
              {itemLevel1?.expandedLevel1 && (
                <SegmentDetailsLevel2 className='segmentRowsLevel2'>
                  {Object.keys(itemLevel1?.dataLevel2)?.length > 0 && <SegmentDetailsLevel2Title>
                    {getL2HeadingFunc(itemLevel1)}
                    <MuiButton
                      variant='outlined'
                      color='light'
                      startIcon={<IconClose />}
                      onClick={(e) => expandLevel1Func(key)}
                    />
                  </SegmentDetailsLevel2Title>}
                  <SegmentDetailsLevel2ListingLHS>

                    {Object.keys(itemLevel1?.dataLevel2).map((data, j) => {
                      const showLevel2Button = expandLevel2Func(key, j, data, true)
                      const selected = itemLevel1.expandedLevel2 && itemLevel1?.expandedLevel2Index === j
                      const selectedItemsL2 = {}
                      const arr2 = segmentDataL1Filtered[filterType]
                      for (let s = 0; s < arr2.length; s++) {
                        if (itemLevel1.dataLevel2[data][arr2[s]]) {
                          // itemLevel1.dataLevel2[data][arr2[s]].insightsElementType = insightsElementType;
                          selectedItemsL2[arr2[s]] = itemLevel1.dataLevel2[data][arr2[s]]
                        }
                      }

                      let hadNextLevel = false
                      const itemL2 = Object.keys(selectedItemsL2)
                      for (let i = 0; i < itemL2.length; i++) {
                        if (selectedItemsL2[itemL2[i]]?.DriverSubAttributes) {
                          hadNextLevel = true
                          break
                        }
                      }

                      if (Object.keys(selectedItemsL2).length === 0) { return false }
                      const isExpandClicked = (selected) ? 'Collaspe' : 'Expand'

                      return (
                        <SegmentAccordionLevel2Wrap key={j} className='segmentRowsLevel2List'>
                          {hadNextLevel && showLevel2Button && (
                            <SegmentAccordionLevel2Heading
                              className={selected ? 'selected' : ''}
                              onClick={(e) => {
                                if(selected) closeLevel3(key)
                                else expandLevel2Func(key, j, data)
                              }}
                            >
                              {data}
                              <MuiIconButton size='small' tooltip={isExpandClicked} align='right'>
                                <IconReportSearch />
                              </MuiIconButton>
                            </SegmentAccordionLevel2Heading>
                          )}
                          {!hadNextLevel && showLevel2Button && (
                            <SegmentAccordionLevel2Heading style={{ cursor: 'default' }}>
                              {data}
                            </SegmentAccordionLevel2Heading>
                          )}
                          {!showLevel2Button && (
                            <SegmentAccordionLevel2Heading>{data}</SegmentAccordionLevel2Heading>
                          )}
                          <SegmentAccordionLevel2Details>
                            {showTableGrid === 'graph' && (
                              <BarGraphsWrapper
                                insightsElementType={insightsElementType}
                                keyOrdering={keyOrdering}
                                item={selectedItemsL2}
                                maxValue={itemLevel1?.expandedLevel2MaxValue}
                                level='L2'
                              />
                            )}
                            {showTableGrid === 'table' && (
                              <TableGraphsWrapper
                                keyOrdering={keyOrdering}
                                item={selectedItemsL2}
                                maxValue={itemLevel1?.expandedLevel2MaxValue}
                              />
                            )}
                          </SegmentAccordionLevel2Details>

                          {data === itemLevel1.expandedLevel2Key && Object.keys(segmentDataLevel3)?.length > 0 && 
                            <SegmentDetailsLevel2ListingRHS className='segmentRowsLevel3'>
                              <SegmentLevel3DetailSection
                                keyOrdering={keyOrdering}
                                index={j}
                                segmentDataL1Filtered={segmentDataL1Filtered}
                                subTitle={Object.keys(segmentDataLevel3)}
                                itemData={segmentDataLevel3}
                                heading={itemLevel1.expandedLevel2Key}
                                maxValue={segmentDataLevel3MaxValue}
                                closeLevel3={() => closeLevel3(key)}
                                showTableGrid={showTableGrid}
                                insightsElementType={insightsElementType}
                              />
                            </SegmentDetailsLevel2ListingRHS>
                          }
                        </SegmentAccordionLevel2Wrap>
                      )
                    })}
                  </SegmentDetailsLevel2ListingLHS>

                </SegmentDetailsLevel2>
              )}
            </SegmentRow>
          )
        })}
    </SegmentWrap>
  )
}

export default ComparisonTable

/////////////////////////////////////


const BarGraphsWrapper = ({ keyOrdering, item, insightsElementType, maxValue, level='' }) => {
  const itemKeys = Object.keys(item)
  const finalKeys = keyOrdering.filter((f) => itemKeys.includes(f))

  return (
    <SegmentProductsWrapper>
      {/* {Object.keys(item).map((productKey, ind) => { */}
      {finalKeys.map((productKey, ind) => {
        const productItem = item[productKey]
        let chartData = productItem.data
        if (productItem.Percent === 0) return false
        productItem.DriverAttributeStandouts = getObjectAsArray(productItem?.DriverAttributeStandouts?.DriverAttributeStandout) || [];
        productItem.DriverAttributes = getObjectAsArray(productItem?.DriverAttributes?.DriverAttributeElement) || []
        // const levelIndexingVal = removeSpecialCharFromLhs(productItem?.DriverName || '') + removeSpecialCharFromLhs(productKey) + 'Row' + ind
        const levelIndexingVal = `${removeSpecialCharFromLhs(productItem?.DriverName || productItem?.AttributeName || '')}__${removeSpecialCharFromLhs(productItem?.DriverId || productItem?.AttributeId)}__${removeSpecialCharFromLhs(productKey)}Row__${ind}`
        let showToolTipData = {...productItem, levelIndexing:levelIndexingVal, insightsElementType:insightsElementType};

        if (['SegmentDriversOnlyAnalysisWithoutSentiments'].includes(insightsElementType)) {
          chartData = [{ SearchKeywords: productItem.Percent }];
          showToolTipData = {}
        }


        return (
          <SegmentRowContent key={productKey + ind}>
            <SegmentTitle className='segmentTitle'>
              {productKey}
            </SegmentTitle>
            <BarWrap sx={{ paddingRight: '30px' }} className={productItem?.type?.toLowerCase()}>
              <ChartBarHorizontalCustom
                showInside={false}
                // showToolTip={ !['DriversProgressionWithoutSentiments', 'SearchDriversProgression'].includes(insightsElementType) }
                bottomText={false}
                data={chartData}
                total={productItem.Percent}
                valueInPercent={true}
                maxPercentRatio={maxValue}
                maxWidth='100%'
                rootClass='roundedBars'
                height='10px'

                showToolTip={false}
                toolTipData={showToolTipData}
                // toolTipData={{...productItem, levelIndexing:levelIndexingVal}} // NOT WORKING
              />
            </BarWrap>
          </SegmentRowContent>
        )
      })}
    </SegmentProductsWrapper>
  )
}

const TableGraphsWrapper = ({ keyOrdering, item, maxValue }) => {
  const itemKeys = Object.keys(item)
  const finalKeys = keyOrdering.filter((f) => itemKeys.includes(f))
  return (
    <TableViewRowWithBars type='table'>
      <TableRow>
        <TableViewRowWithBars type='header' data={{insightsElementType:item[finalKeys[0]].insightsElementType}} />
      </TableRow>
      {finalKeys.map((productKey, ind) => {
        const productItem = item[productKey]
        productItem.DriverName = productKey
        if (productItem.Percent === 0) return false

        return (
          <TableRow key={productKey + ind}>
            <TableViewRowWithBars type='row' data={productItem} maxValue={maxValue} />
          </TableRow>
        )
      })}
    </TableViewRowWithBars>
  )
}

const SegmentLevel3DetailSection = ({
  keyOrdering,
  index,
  segmentDataL1Filtered,
  subTitle,
  heading,
  itemData,
  maxValue,
  closeLevel3,
  showTableGrid,
  insightsElementType
}) => {
  const selectedItemsL3Array = []

  for (let r = 0; r < subTitle.length; r++) {
    const selectedItemsL3 = []
    const data = subTitle[r]
    const arr3 = segmentDataL1Filtered?.segments || segmentDataL1Filtered?.periods
    for (let s = 0; s < arr3.length; s++) {
      if (itemData[data][arr3[s]]) {
        // itemData[data][arr3[s]].insightsElementType = insightsElementType;
        selectedItemsL3.push({
          data: { [arr3[s]]: itemData[data][arr3[s]] },
          title: data,
        })
      }
    }

    if (Object.keys(selectedItemsL3).length > 0) {
      selectedItemsL3Array.push(selectedItemsL3)
    }
  }

  if (Object.keys(selectedItemsL3Array).length === 0) return false

  return (
    <>
      <SegmentAccordionLevel3Heading className='segmentRowsLevel3Heading'>
        {heading}{' '}
        <MuiButton
          variant='outlined'
          color='light'
          startIcon={<IconClose />}
          onClick={(e) => closeLevel3()}
        />
        {/* <IconButton size='small' onClick={(e) => closeLevel3()}>
          <ClosePopup />
        </IconButton> */}
      </SegmentAccordionLevel3Heading>
      {selectedItemsL3Array.map((data, k) => {
        const title = data[0].title
        const finalData = data.map((d) => d.data)

        return (
          <SegmentAccordionLevel3Wrap key={k}>
            {finalData.length > 0 && (
              <SegmentAccordionLevel3SubHeading>{title}</SegmentAccordionLevel3SubHeading>
            )}
            {finalData.length > 0 && (
              <SegmentAccordionLevel3Details>
                {showTableGrid === 'graph' && finalData.map((d2, j) => (
                  <BarGraphsWrapper
                    insightsElementType={insightsElementType}
                    keyOrdering={keyOrdering}
                    key={j}
                    item={d2}
                    maxValue={maxValue}
                    level='L3'
                  />
                ))}
                {showTableGrid === 'table' && finalData.map((d2, j) => (
                  <TableGraphsWrapper
                    keyOrdering={keyOrdering}
                    key={j}
                    item={d2}
                    maxValue={maxValue}
                  />
                ))}
              </SegmentAccordionLevel3Details>
            )}
          </SegmentAccordionLevel3Wrap>
        )
      })}
    </>
  )
}
